export const TaskMap = (franchiseeTitle, standardFranchiseeUniqueName) => {
  return {
    modelClusterName: '开店区域',
    targetAdress: '目标城市',
    manager: '开发人员',
    businessModeName: '业务模式',
    standardFranchiseeName: `${franchiseeTitle}/${standardFranchiseeUniqueName}`,
    followingStatusName: '跟进状态',
    expectDropInDate: '期望落位日期',
    signShopCount: '周边500m门店', // 圈内已签约门店
    emergencyDegreeName: '紧急度',
  };
};

export interface LatLongItem{
  lng:number;
  lat:number
}

export interface CityIds{
  provinceId:number;
  cityId:number;
  districtId:number;
}

export interface ShopBasic {
  id:number;
  type:number;
  name:string;
  icon:string;
  color:string;
  address:string;
  status:number;
  statusName:string;
  openDate:string;
  closeDate:string;
  closeReason:string;
  chancePointId:number;
  logo:string;
}

export type ShopItem = ShopBasic&CityIds&LatLongItem

export interface ModelClusterInfo {
  modelClusterId:number;
  modelClusterName:string;
  centerLng:number;
  centerLat:number;
  radius:number;
  polygon:Array<LatLongItem>;
  shopList:Array<ShopItem>
}

export interface RelateChancePointProtectInfo {
  approvalId: number;
  statusName: string; // "保护中",
  scopeProtection: string; // "直线距离500m",
  daysToExpiration: string; // "48天",
  protectRadius: number; // 500
  applyUserName?: string;
  applyUserId?: number;
}
export interface RelateChancePoint {
  address: string;
  id: number;
  lat: string;
  lng: string;
  name: string;
  protectInfo: RelateChancePointProtectInfo;
  releaseButton: number;
  requiredNum: number;
  requiredTotalNum: number;
  shopImgUrls: any;
  status: number;
  statusName: string;
  updateAt: string;
}
